export const medicationsData = {
  data: [
    {
      product_ndc: '75834-040',
      generic_name: 'GUAIFENESIN, DEXTROMETHORPHAN HYDROBROMIDE, and PHENYLEPHRINE HYDROCHLORIDE',
      brand_name: 'Nivanex DMX',
      product_id: '75834-040_325d6315-5d2b-49d6-b5b7-b5918c48c048',
      dosage_form: 'TABLET',
      route: ['ORAL'],
    },
    {
      product_ndc: '75957-003',
      generic_name: 'Dimethicone and Zinc Oxide',
      brand_name: 'Boogie Bottoms',
      product_id: '75957-003_c07c6cfb-d6dc-44fb-8226-2beab465103c',
      dosage_form: 'SPRAY',
      route: ['TOPICAL'],
    },
    {
      product_ndc: '76420-032',
      generic_name: 'Ketorolac Tromethamine',
      brand_name: 'Ketorolac Tromethamine',
      product_id: '76420-032_b3ba4201-3725-7f6f-e053-2a95a90a6f5b',
      dosage_form: 'Injection',
      route: ['SUBCUTANEOUS'],
    },
  ],
  isFDA: true,
};
